// extracted by mini-css-extract-plugin
module.exports = {"slider_container":"player-progress_slider_container__A5EkG","duration":"player-progress_duration__I_lor"};